import { Link } from 'react-router-dom';
import routePermissions from './config/routePermissions';
import { ModuleIcons, getModuleDescription } from './ModuleIcons';
import './Home.css';

const Home = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const visibleRoutes = routePermissions.filter(r => r.friendlyName && r.roles.some(fn => fn()));

  return (
    <div className="home-container">
      <div className="home-header">
        <h1>¡Bienvenido a Kama y Kanape!</h1>
      </div>

      <div className="modules-grid">
        {visibleRoutes.map(({ path, friendlyName }) => (
          <Link key={path} to={path} className="module-item">
            <div className="module-image">
              {ModuleIcons[friendlyName] || ModuleIcons['Ajustes']}
            </div>
            <h3 className="module-title">{friendlyName}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home;
